import React, { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";

import componentStyles from "assets/theme/views/auth/login";
import componentStylesButtons from "assets/theme/components/button";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import UtilsFncs from "utils/UtilsFncs";
import PasswordField from "components/_refactor/fields/password";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

function Alert({ text }) {
  return (
    <ReactBSAlert
      success
      style={{ display: "block", marginTop: "-100px" }}
      title="Senha alterada."
      onConfirm={UtilsFncs.RedirectToLoginPage}
      onCancel={UtilsFncs.RedirectToLoginPage}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

function AlertError({ text, closeAlert }) {
  return (
    <ReactBSAlert
      error
      style={{ display: "block", marginTop: "-100px" }}
      title="Ops"
      onConfirm={closeAlert}
      onCancel={closeAlert}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

export default function RecoverPassword() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const closeAlert = React.useCallback(() => setalert(null), []);
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmationPassword, setConfirmationPassword] = useState("");
  const [alert, setalert] = React.useState(false);
  const [token, setToken] = React.useState("");
  const [login, setLogin] = React.useState("");
  const [passwordIsOk, setPasswordIsOk] = useState(false);
  const location = useLocation();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const submit = useCallback(async () => {
    setLoading(true);

    await Api.post(
      "change-password",
      "login",
      { senhaAtual: token, senhaNova: newPassword, login: login },
      true
    )
      .then((res) => {
        if (res?.Result?.Trocou) {
          setalert(<Alert text={"Senha alterada com sucesso!"} />);
        } else {
          setalert(
            <AlertError
              text={
                "Ocorreu um erro ao alterar sua senha. Verifique os parâmetros informados."
              }
              closeAlert={closeAlert}
            />
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          error === "HTTPERRO 422 A senhaAtual não está correta. Verifique."
        ) {
          setalert(
            <AlertError
              text={"Senha atual não está correta. Verifique."}
              closeAlert={closeAlert}
            />
          );
        } else {
          setalert(
            <AlertError
              text={
                "Ocorreu um erro ao alterar sua senha. Verifique os parâmetros informados."
              }
              closeAlert={closeAlert}
            />
          );
        }
        setLoading(false);
      });
  }, [closeAlert, login, newPassword, token]);

  async function CheckTokenAndEmal() {
    try {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get("token");
      const email = searchParams.get("email");
      if (!token || !email) {
        setError(true);
        setErrorMessage("Token ou email não encontrado");
        return;
      }
      const response = await Api.get(
        `/auth/check-token?token=${token}&email=${email}`
      );
      if (response.data.valid) {
        setSuccess(true);
        setSuccessMessage("Token válido");
      } else {
        setError(true);
        setErrorMessage("Token inválido");
      }
    } catch (error) {
      setError(true);
      setErrorMessage("Erro ao validar token");
    }
  }

  useEffect(() => {
    CheckTokenAndEmal();
  }, [location.search]);

  return (
    <>
      {alert}
      <Container maxWidth="sm">
        <Card classes={{ root: classes.card }}>
          <CardHeader
            className={classes.cardHeader}
            title="Preencha a nova senha de acordo com os critérios."
            titleTypographyProps={{
              component: Typography,
              variant: "h4",
              color: "textSecondary",
              align: "center",
            }}
          />
          <CardContent classes={{ root: classes.cardContent }}>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <PasswordField
                    label="Nova senha"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    strengthInfo
                    white
                    required
                  />
                </Grid>
                <Grid className={classes.fields} item xs={12}>
                  <PasswordField
                    label="Confirme a nova senha"
                    value={confirmationPassword}
                    onChange={(e) => setConfirmationPassword(e.target.value)}
                    white
                    confirmPassword={newPassword}
                    setPasswordIsOk={setPasswordIsOk}
                    required
                  />
                </Grid>
              </Grid>
              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                <Button
                  variant="contained"
                  classes={{ root: classes.buttonContainedInfo }}
                  onClick={submit}
                  disabled={
                    loading ||
                    !passwordIsOk ||
                    !(
                      newPassword?.length &&
                      confirmationPassword?.length &&
                      newPassword === confirmationPassword
                    ) ||
                    MaskAndValid.isNullOrEmpty(newPassword) ||
                    MaskAndValid.isNullOrEmpty(confirmationPassword)
                  }
                >
                  Alterar
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
